// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Offer20 from './Offer20.tsx';
import Offer20Filled from './Offer20Filled.tsx';
import Offer20CircleFilled from './Offer20CircleFilled.tsx';
import Offer24 from './Offer24.tsx';
import Offer24Filled from './Offer24Filled.tsx';
import Offer24CircleFilled from './Offer24CircleFilled.tsx';
import Offer40 from './Offer40.tsx';
import Offer40Filled from './Offer40Filled.tsx';
import Offer48 from './Offer48.tsx';
import Offer48Filled from './Offer48Filled.tsx';

type OfferProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Offer20,
    Offer20Filled,
    Offer20CircleFilled,
    Offer24,
    Offer24Filled,
    Offer24CircleFilled,
    Offer40,
    Offer40Filled,
    Offer48,
    Offer48Filled,
};

const Offer: FC<OfferProps> = ({ variation, ...props }) => {
    const variationKey = `Offer${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Offer" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Offer;
